import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import RuleIcon from "@mui/icons-material/Rule";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import CompaniesMissingRequiredModal from "@/components/anchorData/companiesMissingRequiredModal";
import {
  type CompaniesMissingRequiredFilters,
  type CompanyMissingRequiredRow,
  DEFAULT_COMPANIES_MISSING_REQUIRED_FILTERS,
  useCompaniesMissingRequiredAnchorData,
} from "@/components/anchorData/useCompaniesMissingRequiredAnchorData";
import styles from "@/components/anchorData/anchorData.module.css";

interface CompaniesMissingRequiredButtonProps {
  onSelectCompany: (company: CompanyMissingRequiredRow) => Promise<boolean>;
}

const CompaniesMissingRequiredButton: FC<
  CompaniesMissingRequiredButtonProps
> = ({ onSelectCompany }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [filters, setFilters] = useState<CompaniesMissingRequiredFilters>(
    DEFAULT_COMPANIES_MISSING_REQUIRED_FILTERS
  );
  const { status, rows, load } = useCompaniesMissingRequiredAnchorData();

  const handleOpen = () => {
    setModalOpen(true);
    void load(filters);
  };

  const handleFiltersChange = (nextFilters: CompaniesMissingRequiredFilters) => {
    setFilters(nextFilters);
    void load(nextFilters);
  };

  const handleSelectCompany = async (company: CompanyMissingRequiredRow) => {
    const companySelected = await onSelectCompany(company);
    if (companySelected) {
      setModalOpen(false);
    }
  };

  return (
    <>
      <GenericButton
        variant="outlined"
        startIcon={<RuleIcon />}
        onClick={handleOpen}
        className={styles.topBarButton}
      >
        {t("anchordata_incomplete_companies")}
      </GenericButton>

      <CompaniesMissingRequiredModal
        open={modalOpen}
        status={status}
        rows={rows}
        filters={filters}
        onFiltersChange={handleFiltersChange}
        onSelectCompany={handleSelectCompany}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default CompaniesMissingRequiredButton;
